export default __webpack_public_path__ + "static/media/solar.3ea105b1.png";